import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_FACEBOOK } from './router';

menuRegistry.registerMenu([
    {
        parent: 'ThirdParty',
        key: 'Facebook',
        name: 'Facebook',
        icon: 'fab fa-facebook',
        route: { name: ROUTE_NAME_FACEBOOK }
    }
]);
export default registerRouteForModule(router);
